/* eslint-disable react/jsx-no-leaked-render */
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useMemo } from 'react'

import { PLGHandler } from '../shadCN/PLGHandler'

import { withPermissionCheck } from '@/hoc/WithPermissionCheck'
import { InfoTooltip } from '@/views/NewBuilder/components/InfoTooltip/InfoTooltip'

/**
 *
 * @param {*} param0
 *  - options: array of 2 button objects with name, value, and label properties;
 *  - value: string value of the selected button;
 *  - onChange: function to handle the change event;
 *
 */
function ToggleButtons({
  options = [],
  value = '',
  onChange = () => {},
  activeStyles = {},
  inactiveStyles = {},
  toggleButtonStyles = {},
  buttonStyles = {},
  ...rest
}) {
  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      aria-label="mode selector"
      size="large"
      sx={{
        '& > div': {
          width: '100%',
        },
        padding: '4px',
        border: '1px solid #EAECF0',
        borderRadius: '16px',
        ...toggleButtonStyles,
      }}
      value={value}
      onChange={onChange}
      {...rest}
    >
      {options?.map(button => (
        <HOCToggleButton
          key={button.name}
          aria-label={button.name}
          requiredPermission={button.requiredPermission}
          sx={{
            '&.MuiToggleButton-root.Mui-selected': {
              bgcolor: '#fff',
              color: '#344054',
              border: 'none',
              borderRadius: '16px',
              boxShadow: 'none',
              fontWeight: '500',
              py: '8px',
              px: '10px',
              '&:hover': {
                bgcolor: '#fff',
              },
              '&:disabled': {
                opacity: 0.5,
                cursor: 'not-allowed',
              },
              ...activeStyles,
            },
            // inactive styles
            '&.MuiToggleButton-root': {
              color: '#667085',
              border: 'none',
              boxShadow: 'none',
              borderRadius: '16px',
              py: '8px',
              px: '10px',

              fontSize: '14px',
              '&:hover': {
                bgcolor: 'unset',
              },
              '&:disabled': {
                opacity: 0.5,
                cursor: 'not-allowed',
              },
              ...buttonStyles,
            },
          }}
          value={button.value}
          {...button?.props}
        >
          {button.label}
        </HOCToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default ToggleButtons

function ToggleButtonWrapper({ handleOpenPopover, handleClosePopover, requiredPermission, ...props }) {
  return (
    <Stack alignItems="center" direction="row" gap="0px" position="relative" width="100%">
      <ToggleButton {...props} disabled={Boolean(props.disabled && requiredPermission)} />

      <PLGHandler
        style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', right: '35px', width: '18px' }}
        visible={Boolean(props.disabled && requiredPermission)}
        onMouseEnter={handleOpenPopover}
      />
    </Stack>
  )
}

function HOCToggleButton({ requiredPermission, ...props }) {
  const Component = useMemo(() => withPermissionCheck(ToggleButtonWrapper, requiredPermission), [requiredPermission])

  return <Component {...props} requiredPermission={requiredPermission} />
}
